/* UTF-8 admin tab: safety */
import React from 'react'

export function renderSafety(ctx) {
  const {
    activeTab,
    training,
  } = ctx
  return (
    <>
          {activeTab === 'safety' && (
            <div className="dash-section">
              <div className="dash-section-header">
                <h2>🛡️ Safety Policy</h2>
                <p>Workplace safety protocols, emergency procedures, and compliance requirements for Groupe Ouambo operations.</p>
              </div>
              <div className="dash-policy-doc">
                <div className="dash-policy-section">
                  <h3>1. Personal Protective Equipment (PPE)</h3>
                  <p>All operational personnel are required to wear appropriate PPE at all times on work sites:</p>
                  <ul>
                    <li>🪖 <strong>Safety helmet</strong> — mandatory on all job sites and loading/unloading areas</li>
                    <li>🦺 <strong>High-visibility vest</strong> — mandatory in vehicle yards and warehouses</li>
                    <li>🥾 <strong>Safety boots</strong> — anti-puncture soles and steel toe caps</li>
                    <li>🧤 <strong>Protective gloves</strong> — when handling goods, materials, or chemicals</li>
                    <li>🥽 <strong>Safety goggles</strong> — dusty zones, welding, chemical handling</li>
                  </ul>
                </div>
                <div className="dash-policy-section">
                  <h3>2. Vehicle and Transport Safety</h3>
                  <ul>
                    <li>Mandatory pre-departure vehicle check (fluids, brakes, lights, tyres)</li>
                    <li>Seatbelts mandatory at all times for all occupants</li>
                    <li>Speed limits: 80 km/h national roads · 40 km/h urban areas</li>
                    <li>Zero tolerance for driving under influence of alcohol or drugs</li>
                    <li>Mandatory 30-minute rest every 4 hours of continuous driving</li>
                    <li>Immediate supervisor notification of any accident or incident</li>
                  </ul>
                </div>
                <div className="dash-policy-section">
                  <h3>3. Manual Handling and Storage</h3>
                  <ul>
                    <li>Max manual load: 25 kg per person (straight-back lifting technique)</li>
                    <li>Use mechanical lifting aids for loads exceeding 25 kg</li>
                    <li>Hazardous materials (fuel, chemicals) must be labeled, separated, and stored per MSDS</li>
                    <li>Emergency exits must remain unobstructed at all times</li>
                    <li>Verify pallet and racking stability before any manipulation</li>
                  </ul>
                </div>
                <div className="dash-policy-section">
                  <h3>4. Emergency Procedures</h3>
                  <ul>
                    <li>🔥 <strong>Fire:</strong> Activate alarm → Evacuate via nearest exit → Call emergency services → Do NOT use elevators → Proceed to assembly point</li>
                    <li>⚕️ <strong>Injury/Medical:</strong> Call safety officer → Locate first aid kit → Do not move injured person unless in immediate danger → Document incident within 24h</li>
                    <li>☣️ <strong>Hazardous spill:</strong> Isolate area → Notify HSE Manager immediately → Follow MSDS instructions → Do not attempt cleanup without training</li>
                    <li>📍 <strong>Assembly point:</strong> All personnel must know the designated assembly point for their site</li>
                  </ul>
                </div>
                <div className="dash-policy-section">
                  <h3>5. Incident Reporting and Investigation</h3>
                  <p>All incidents (accidents, near-misses, unsafe conditions) must be reported within 24 hours. Admin responsibilities: investigate root cause, implement corrective action within 48 hours of critical incidents, file report with HSE manager, retain records for 5 years.</p>
                </div>
                <div className="dash-policy-section">
                  <h3>6. Safety Training Requirements</h3>
                  <ul>
                    <li>All new employees: mandatory safety induction within first week</li>
                    <li>Drivers: defensive driving refresher every 2 years</li>
                    <li>Warehouse staff: manual handling and fire safety annually</li>
                    <li>HSE officers: certified first aid and hazmat handling</li>
                  </ul>
                </div>
                <div className="dash-policy-meta">
                  <p>Approved by Executive Management — Groupe Ouambo</p>
                  <p>Current version: January 2025 | Next review: January 2026</p>
                </div>
              </div>
            </div>
          )}

          {/* ── CAREERS ─────────────────────────────────────── */}
    </>
  )
}
